import type { MutationHookOptions } from "@apollo/client";
import { gql, useMutation } from "@apollo/client";

import type { SearchHistoriesDeleteInput } from "@shared/types/graphqlGenerated";

const SearchHistoriesDelete_Shared_Mutation = gql`
  mutation SearchHistoriesDelete_Shared_Mutation($input: SearchHistoriesDeleteInput!) {
    searchHistoriesDelete(input: $input) {
      errors {
        message
      }
    }
  }
`;

interface Variables {
  input: {
    searchHistoryId: SearchHistoriesDeleteInput["searchHistoryId"];
  };
}

const useSearchHistoriesDeleteMutation = (options?: MutationHookOptions<null, Variables>) => {
  return useMutation<null, Variables>(SearchHistoriesDelete_Shared_Mutation, options);
};

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useSearchHistoriesDeleteMutation, SearchHistoriesDelete_Shared_Mutation };
